export enum InstalmentProgram {
  Mcinst = 'MCINST',
}
